import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-[#f3f7fa] text-slate-950" }
const _hoisted_2 = { class: "mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-10" }

import { onMounted, onUnmounted } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'PublicLayout',
  setup(__props) {

const previousTitle = document.title
onMounted(() => { document.title = "Нежелательное событие — Республиканская больница №1" })
onUnmounted(() => { document.title = previousTitle })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<header class=\"relative overflow-hidden bg-gradient-to-r from-[#075f73] via-[#08768b] to-[#0b8291] text-white shadow-sm\"><div class=\"absolute -right-16 -top-24 h-64 w-64 rounded-full border-[38px] border-white/5\"></div><div class=\"mx-auto flex max-w-5xl items-center gap-4 px-4 py-5 sm:px-6 sm:py-6\"><div class=\"grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-white shadow-lg shadow-slate-950/10\" aria-hidden=\"true\"><span class=\"relative block h-8 w-8 before:absolute before:left-3 before:h-8 before:w-2 before:rounded-sm before:bg-[#e24b4b] after:absolute after:top-3 after:h-2 after:w-8 after:rounded-sm after:bg-[#e24b4b]\"></span></div><div><div class=\"text-xs font-semibold uppercase tracking-[0.18em] text-cyan-100\">Республика Тыва</div><div class=\"mt-1 text-lg font-bold leading-tight sm:text-xl\">Республиканская больница №1</div><div class=\"mt-1 text-sm text-cyan-50/90\">Профессиональная забота о вашем здоровье</div></div></div></header>", 1)),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("footer", { class: "border-t border-slate-200 bg-white" }, [
      _createElementVNode("div", { class: "mx-auto grid max-w-5xl gap-2 px-4 py-5 text-xs text-slate-500 sm:grid-cols-2 sm:px-6" }, [
        _createElementVNode("div", null, "ГБУЗ РТ «Республиканская больница №1» · г. Кызыл, ул. Оюна Курседи, 163"),
        _createElementVNode("div", { class: "sm:text-right" }, [
          _createTextVNode("Горячая линия: "),
          _createElementVNode("a", {
            class: "font-medium text-[#08768b]",
            href: "tel:+73942260106"
          }, "8 (39422) 6-01-06")
        ])
      ])
    ], -1))
  ]))
}
}

})